<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 hourly-sales" id="hourly-sales">
  <po-widget>
    <div class="po-row">
      <div class="po-xl-7 po-lg-7 po-md-7 po-sm-7 po-pt-0 po-pl-0">
        <span class="po-font-text-bold title">Aniversariantes do período</span>
        <span class="po-ml-1 po-icon po-icon-xml pointer-cursor" *ngIf="!loading && !errorApi" (click)="downloadExcel()"></span>
      </div>
      <div class="po-xl-5 po-lg-5 po-md-5 po-sm-5" *ngIf="!loading && !errorApi">
        <po-select name="select" [p-options]="listItem" (p-change)="recoverProduct($event)" [ngModel]="typeSelected"></po-select>
      </div>
    </div>
    <div class="icon-loading" *ngIf="loading && !errorApi">
      <app-loading-icon></app-loading-icon>
    </div>
    <div *ngIf="!loading && errorApi">
      <app-error [message]="message"></app-error>
    </div>
    <div class="po-table-main-container" *ngIf="!loading && !errorApi">
      <div class="po-table-wrapper" style="opacity: 1">
        <div style="height: 300px; overflow-y: auto; min-width: 500px;">
          <table class="po-table" id="minhaTabela">
            <thead>
              <tr class="po-table-header">
                <th class="po-table-header-ellipsis pointer-cursor" (click)="ordenarTabela('cliente')">
                  <div class="po-table-header-flex">
                    <span class="po-table-header-ellipsis"> Cliente </span>
                    <span id="icon-cliente" class="po-icon po-icon-arrow-down"></span>
                  </div>
                </th>
                <th class="po-table-header-ellipsis pointer-cursor" (click)="ordenarTabela('data')">
                  <div class="po-table-header-flex">
                    <span class="po-table-header-ellipsis"> Data </span>
                    <span id="icon-data" class="po-icon po-icon-arrow-down"></span>
                  </div>
                </th>
                <th class="po-table-header-ellipsis">
                  <div class="po-table-header-flex">
                    <span class="po-table-header-ellipsis"> Contato </span>
                  </div>
                </th>
                <th class="po-table-header-ellipsis">
                  <div class="po-table-header-flex">
                    <span class="po-table-header-ellipsis"> Ação </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="po-table-group-row" *ngFor="let item of tableItens">
              <tr class="po-table-row">
                <td class="po-table-column" ng-reflect-ng-class="">
                  <div class="po-table-column-cell notranslate">
                    <span *ngIf="isToday(item.data)" class="po-icon po-icon-gift po-mr-1 balanco"></span>
                    <span>{{item.cliente}}</span>
                  </div>
                </td>
                <td class="po-table-column" ng-reflect-ng-class="">
                  <div class="po-table-column-cell notranslate">
                    <span>{{item.data}}</span>
                  </div>
                </td>
                <td class="po-table-column value-column" ng-reflect-ng-class="">
                  <div class="po-table-column-cell notranslate">
                    <span>{{item.contato}}</span>
                  </div>
                </td>
                <td class="po-table-column value-column" ng-reflect-ng-class="">
                  <div class="po-table-column-cell notranslate" style="font-size: 20px; display: flex;">
                    <span id="waIcon" class="po-icon po-icon-social-whatsapp po-mt-1 po-mb-1 pointer-cursor" p-tooltip="Enviar mensagem pelo Whasapp" (click)="sendWa(item.contato)"></span>
                    <span id="copyIcon" class="po-icon po-icon-copy po-m-1 pointer-cursor" p-tooltip="Copiar contato" (click)="copyContact(item.contato)"></span>
                    <span id="chartIcon" class="po-icon po-icon-chart-columns po-m-1 po-ml-0 pointer-cursor" p-tooltip="Estatísticas do cliente" (click)="openChart(item)"></span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </po-widget>
  <app-modal-person-statistics #modalStats [personSelect]="personSelect"
  [personStatisticsInfo]="personStatisticsInfo" [limitPersonInfo]="limitPersonInfo" 
  [openInvoiceValue]="openInvoiceValue" [branchCodes]="branchCodes"></app-modal-person-statistics>
</div>